import type { RadioCardOption } from "../components/FormFields/RadioCardGroup";

// Property Type Options
export const propertyTypeOptions: RadioCardOption[] = [
  {
    label: "Wohnung",
    value: "Wohnung",
    icon: "/Icons/Abfrage/abfrage-immobilienart-wohnung.svg",
  },
  {
    label: "Haus",
    value: "Haus",
    icon: "/Icons/Abfrage/abfrage-immobilienart-haus.svg",
  },
  {
    label: "Gewerbe",
    value: "Gewerbe",
    icon: "/Icons/Abfrage/abfrage-immobilienart-gewerbe.svg",
  },
  {
    label: "Grundstück",
    value: "Grundstück",
    icon: "/Icons/Abfrage/abfrage-immobilienart-grundstuck.svg",
  },
];

// Sub Property Type Options
export const hausSubTypeOptions: RadioCardOption[] = [
  {
    label: "Einfamilienhaus",
    value: "Einfamilienhaus",
    icon: "/Icons/Abfrage/abfrage-immobilienart-haus.svg",
  },
  {
    label: "Zweifamilienhaus",
    value: "Zweifamilienhaus",
    icon: "/Icons/Abfrage/abfrage-immobilienart-haus-zfh.svg",
  },
  {
    label: "Reihenhaus",
    value: "Reihenhaus",
    icon: "/Icons/Abfrage/abfrage-immobilienart-haus-reihenhaus.svg",
  },
  {
    label: "Doppelhaushälfte",
    value: "Doppelhaushälfte",
    icon: "/Icons/Abfrage/abfrage-immobilienart-haus-dhh.svg",
  },
  {
    label: "Villa",
    value: "Villa",
    icon: "/Icons/Abfrage/abfrage-immobilienart-haus-villa.svg",
  },
  {
    label: "Mehrfamilienhaus",
    value: "Mehrfamilienhaus",
    icon: "/Icons/Abfrage/abfrage-immobilienart-haus-mfh.svg",
  },
];

export const gewerbeSubTypeOptions: RadioCardOption[] = [
  {
    label: "Einzelhandel",
    value: "Einzelhandel",
    icon: "/Icons/Abfrage/abfrage-immobilienart-gewerbe-einzelhandel.svg",
  },
  {
    label: "Wohn- und Geschäftshaus",
    value: "Wohn- und Geschäftshaus",
    icon: "/Icons/Abfrage/abfrage-immobilienart-gewerbe-wug.svg",
  },
  {
    label: "Büro- oder Praxisgebäude",
    value: "Büro- oder Praxisgebäude",
    icon: "/Icons/Abfrage/abfrage-immobilienart-gewerbe-buro.svg",
  },
  {
    label: "Mehrfamilienhaus",
    value: "Mehrfamilienhaus",
    icon: "/Icons/Abfrage/abfrage-immobilienart-gewerbe-mfh.svg",
  },
  {
    label: "Sonstige",
    value: "Sonstige",
    icon: "/Icons/Abfrage/abfrage-immobilienart-gewerbe-sonstige.svg",
  },
];

export const grundstuckSubTypeOptions: RadioCardOption[] = [
  {
    label: "Bauland",
    value: "Bauland",
    icon: "/Icons/Abfrage/abfrage-immobilienart-grundstuck-bauland.svg",
  },
  {
    label: "Ackerland",
    value: "Ackerland",
    icon: "/Icons/Abfrage/abfrage-immobilienart-grundstuck-acker.svg",
  },
  {
    label: "Wald und Grünland",
    value: "Wald und Grünland",
    icon: "/Icons/Abfrage/abfrage-immobilienart-grundstuck-wald.svg",
  },
  {
    label: "Sonstiges",
    value: "Sonstiges",
    icon: "/Icons/Abfrage/abfrage-immobilienart-grundstuck-sonstiges.svg",
  },
];

// Quality Options (Step 7)
export const qualityOptions: RadioCardOption[] = [
  {
    label: "Einfach",
    value: "Einfach",
    // description: "Schlechter Wärmeschutz, 1-fach verglaste Fenster",
    icon: "/Icons/Abfrage/abfrage-ausstattung-einfach.svg",
  },
  {
    label: "Normal",
    value: "Normal",
    // description:
    //   "Baujahrstypische Ausstattungsmerkmale, 2-Fach verglaste Fenster",
    icon: "/Icons/Abfrage/abfrage-ausstattung-normal.svg",
  },
  {
    label: "Gehoben",
    value: "Gehoben",
    // description: "Gute Wärmedämmung, 3-Fach verglaste Fenster, Fußbodenheizung",
    icon: "/Icons/Abfrage/abfrage-ausstattung-gehoben.svg",
  },
  {
    label: "Luxuriös",
    value: "Luxuriös",
    // description:
    //   "Hochwertige Dämmung, 3-fach verglaste Fenster, hochwertiger Boden, Fußbodenheizung",
    icon: "/Icons/Abfrage/abfrage-ausstattung-luxuriös.svg",
  },
];

// Equipment Options (legacy - kept for backward compatibility)
export const equipmentOptions = qualityOptions;

// Development Status Options (for Grundstück - legacy)
export const developmentStatusOptions: RadioCardOption[] = [
  {
    label: "Nicht entwickelt",
    value: "Nicht entwickelt",
    icon: "/Icons/Abfrage/abfrage-ausstattung-einfach.svg",
  },
  {
    label: "Teilweise entwickelt",
    value: "Teilweise entwickelt",
    icon: "/Icons/Abfrage/abfrage-ausstattung-normal.svg",
  },
  {
    label: "Voll entwickelt",
    value: "Voll entwickelt",
    icon: "/Icons/Abfrage/abfrage-ausstattung-gehoben.svg",
  },
];

// Condition Options (Step 8) - Reordered to match new schema
export const conditionOptions: RadioCardOption[] = [
  {
    label: "Renovierungsbedürftig",
    value: "Renovierungsbedürftig",
    // description: "Die Nutzung der Immobilie bedarf vorheriger Renovierung",
    icon: "/Icons/Abfrage/abfrage-zustand-renovierung.svg",
  },
  {
    label: "Gut erhalten",
    value: "Gut erhalten",
    // description:
    //   "Die Immobilie wurde gut instand gehalten und teilweise modernisiert",
    icon: "/Icons/Abfrage/abfrage-zustand-gut.svg",
  },
  {
    label: "Neu/kürzlich saniert",
    value: "Neu/kürzlich saniert",
    // description: "Die Wohnung wurde vor kurzem gebaut oder kernsaniert",
    icon: "/Icons/Abfrage/abfrage-zustand-neu.svg",
  },
];

// Usage Options (Step 9) - New
export const usageOptions: RadioCardOption[] = [
  {
    label: "Eigennutzung",
    value: "Eigennutzung",
    icon: "/Icons/Abfrage/abfrage-nutzungsart-eigengenutzt.svg",
  },
  {
    label: "Vermietet",
    value: "Vermietet",
    icon: "/Icons/Abfrage/abfrage-nutzungsart-vermietet.svg",
  },
  {
    label: "Leerstehend",
    value: "Leerstehend",
    icon: "/Icons/Abfrage/abfrage-nutzungsart-leerstehend.svg",
  },
];

// Property Features (Step 6) - Checkbox options
export interface CheckboxOption {
  label: string;
  value: string;
}

export const propertyFeaturesOptions: CheckboxOption[] = [
  { label: "Balkon/Terrasse", value: "balcony" },
  { label: "Garten", value: "garden" },
  { label: "Garage", value: "garage" },
  { label: "Keller", value: "basement" },
  { label: "Außenstellplatz", value: "parking" },
  { label: "Aufzug", value: "elevator" },
];

// Reason Options
export const reasonOptions: RadioCardOption[] = [
  {
    label: "Verkaufsabsicht",
    value: "Verkaufsabsicht",
    icon: "/Icons/Abfrage/abfrage-grund-verkaufsabsicht.svg",
  },
  {
    label: "Kaufabsicht",
    value: "Kaufabsicht",
    icon: "/Icons/Abfrage/abfrage-grund-kaufabsicht.svg",
  },
  {
    label: "Anderer Grund",
    value: "Anderer Grund",
    icon: "/Icons/Abfrage/abfrage-grund-anderergrund.svg",
  },
];

// Timeline Options
export const timelineOptions: RadioCardOption[] = [
  { label: "1-3 Monate", value: "1-3 Monate" },
  { label: "4-12 Monate", value: "4-12 Monate" },
  { label: "> 12 Monate", value: "> 12 Monate" },
];

// Basement Options
export const basementOptions = [
  { label: "Ja", value: "Ja" },
  { label: "Nein", value: "Nein" },
];
